var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","appear":""}},[_c('div',{staticClass:"bottomhints",style:({ height: (_vm.height + "px"), minHeight: _vm.minHeight })},[_c('div',{staticClass:"hint-body"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83a028c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/strip-block-custom??ref--0-0!./src/components/BottomHints.vue
// module id = 2370
// module chunks = 1706 1709 1710 1713 1728